import { useState } from 'react';
import facebook from '../../../../assets/socialIcons/facebook.png';
import linkedin from '../../../../assets/socialIcons/linkedin.png';
import instagram from '../../../../assets/socialIcons/instagram.png';
import pintrest from '../../../../assets/socialIcons/pintrest.png';

const Analytics = () => {
  const sites = [
    'Overview',
    'Facebook',
    'Instagram',
    'Twitter',
    'Pinterest',
    'Tiktok',
    'LinkedIn',
  ];
  const [selectedSite, setSelectedSite] = useState(sites[0]);
  const setIcon = (siteName) => {
    switch (siteName) {
      case sites[1]:
        return facebook;
      case sites[2]:
        return instagram;
      case sites[3]:
        return facebook;
      case sites[4]:
        return pintrest;
      case sites[5]:
        return instagram;
      case sites[6]:
        return linkedin;
    }
  };
  return (
    <div className="bg-lightblue">
      <div className="py-1 px-5 border flex">
        <div className="flex flex-[0.65] space-x-4">
          {sites.map((el) => (
            <a
              className={`${selectedSite === el ? 'font-semibold' : ''}`}
              onClick={() => setSelectedSite(el)}
              href="#"
            >
              {el}
            </a>
          ))}
        </div>
        <p>
          Filters <i className="fa-solid fa-filter"></i>
        </p>
      </div>

      <div className="p-4 flex flex-[0.65] space-x-3">
        {sites.slice(1, sites.length).map((siteName) => (
          <SiteFollowerCard
            siteName={siteName}
            company={'Nike'}
            socialIcon={setIcon(siteName)}
          />
        ))}
      </div>
    </div>
  );
};

const SiteFollowerCard = ({ siteName, company, socialIcon }) => {
  return (
    <div className="w-[120px] h-[120px] bg-white border rounded-md flex flex-col space-y-3 p-2">
      <div className="flex space-x-1">
        <img className="w-10 h-10" src={socialIcon} alt="social icon" />
        <div className="flex flex-col">
          <p className="text-xs">{siteName}</p>
          <p className="text-xs">{company}</p>
        </div>
      </div>
      <div className="flex flex-col">
        <p className="text-xs">Followers</p>
        <p className="text-lg font-semibold">297M</p>
      </div>
    </div>
  );
};
export default Analytics;
